export const DOWNLOAD_API = {
  exportPendingFees: '/api/absa/account/export/pendingfees',
  exportNotes: '/api/absa/note/export',
  exportAccounts: '/api/absa/account/export',
  allNotes: '/api/absa/note',
  confirmationSummary: '/api/absa/documentation/note/2022-FS-001/summary',
  // year in yyyy format, month in M format
  exportNoteStatement: (noteId: string, year: string, month: string) =>
    `/api/absa/note/${noteId}/statement/${year}/${month}`,
  exportLiveStatement: (noteId: string) => `/api/absa/note/${noteId}/statement/latest`,
  exportPreviousStatements: (noteId: string) => `/api/absa/note/${noteId}/statements/previous`,
  exportLiveStatementsForMultipleNotes: (noteIds: string[]) =>
    `/api/absa/note/statements?ids=${noteIds.join(',')}`,
  exportTradeConfirmation: (accountId: string, documentNumber: number) =>
    `/api/absa/documentation/account/${accountId}/${documentNumber}`,
  exportTaxReport: (startDate: string, endDate: string, counterpartyIds: string[]) =>
    `api/absa/taxreport/${startDate}/${endDate}/${counterpartyIds}`,
  exportIT3BbyDate: (date: string) => `/api/absa/reports/${date}/it3b/export`,
  exportIT3CbyDate: (date: string) => `/api/absa/reports/${date}/it3c/export`,
  exportInterimTaxReport: (year: string, reportType: string) =>
    `/api/absa/reports/${year}/${reportType}/interim/export`,
  exportPortfolioFactSheet({
    month,
    portfolioId,
    year
  }: {
    month: string
    portfolioId: string
    year: string
  }) {
    return `/api/absa/portfolio/${portfolioId}/portfolioFactSheet/${year}/${month}`
  },
  exportPortfolioDailyReturnsExcel: (portfolioId: string) =>
    `/api/absa/portfolio/${portfolioId}/dailyReturns/excel`,
  exportFullTaxReport: (year: string, reportType) =>
    `/api/absa/reports/${year}/${reportType}/full/export`,
  exportReportOverview: `/api/absa/riskmanagement/export/static`,
  exportRiskReport: `/api/absa/riskmanagement/export`,
  exportHoldingsReport: `/api/absa/riskmanagement/export/holdingsreport`,
  tradeConfirmationDocument: (tradeId: string, documentNumber: number) =>
    `/api/absa/documentation/account/${tradeId}/${documentNumber}`,
  exportNoteReport: (
    counterpartyIds: string,
    startDateInclusive: string,
    endDateInclusive: string,
    maximumNumberResults: number
  ) =>
    `/api/absa/note/export/filter?counterpartyIds=${counterpartyIds}&startDateInclusive=${startDateInclusive}&endDateInclusive=${endDateInclusive}&maximumNumberResults=${maximumNumberResults}`
}
